import { useEffect, useRef } from "react";
import { PageShell } from "../components/PageShell";
import { Badge, Card } from "@weretradeit/ui-react";

const specUrl = (import.meta.env.VITE_DOCS_SPEC_URL as string | undefined) || "/docs/api/specs/docs-service";

const apiEndpoints = [
  { method: "GET", path: "/design/api/tokens", description: "Returns flattened design tokens." },
  { method: "GET", path: "/design/api/footer", description: "Shared footer markup + metadata." },
  { method: "GET", path: "/design/api/navigation", description: "Navigation items used across services." }
];

export const ApiPage = () => {
  const redocInitialized = useRef(false);

  useEffect(() => {
    // Initialize Redoc once the script is loaded
    if (redocInitialized.current) return;

    const initRedoc = () => {
      const container = document.getElementById('redoc-container');
      if (container && (window as any).Redoc) {
        (window as any).Redoc.init(specUrl, {
          scrollYOffset: 50,
          hideDownloadButton: false,
          theme: {
            colors: {
              primary: { main: '#0066cc' }
            }
          }
        }, container);
        redocInitialized.current = true;
      }
    };

    // Check if Redoc is already loaded
    if ((window as any).Redoc) {
      initRedoc();
    } else {
      // Wait for script to load
      window.addEventListener('redoc-loaded', initRedoc);
      return () => window.removeEventListener('redoc-loaded', initRedoc);
    }
  }, []);

  return (
    <PageShell
      pageTitle="API Documentation"
      subtitle="REST endpoints and OpenAPI specifications for the services portal"
      breadcrumbs={[
        { label: "Home", href: "/" },
        { label: "Service System", href: "/" },
        { label: "API" }
      ]}
    >
      <Card title="REST API Endpoints">
        <table className="token-grid">
          <thead>
            <tr>
              <th>Method</th>
              <th>Endpoint</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {apiEndpoints.map((endpoint) => (
              <tr key={endpoint.path}>
                <td><Badge tone="info">{endpoint.method}</Badge></td>
                <td><code>{endpoint.path}</code></td>
                <td>{endpoint.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <Card title="API Docs Viewer">
        <p>ReDoc rendering of the Docs Service OpenAPI spec.</p>
        <div id="redoc-container" style={{ border: "1px solid var(--border)", borderRadius: 12, overflow: "hidden", background: "#fff" }} />
        <p className="muted" style={{ marginTop: 8 }}>
          Spec source: {specUrl}. Set VITE_DOCS_SPEC_URL to override (e.g., local dev URL).
        </p>
      </Card>
    </PageShell>
  );
};
